import React from 'react';
import { motion } from 'framer-motion';

export default function Hero() {
  const scrollToWaitlist = () => {
    const element = document.getElementById('waitlist');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="w-full py-16 md:py-32">
      <div className="max-w-4xl">
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.21, 0.47, 0.32, 0.98] }}
          className="text-5xl sm:text-6xl md:text-8xl font-extrabold tracking-tight leading-[0.95] text-navy"
        >
          Your child deserves better.<br />
          <span className="text-deep-blue">So does their school.</span>
        </motion.h1>
        
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.2, ease: [0.21, 0.47, 0.32, 0.98] }}
          className="mt-8 md:mt-12 text-xl md:text-2xl font-medium text-navy/70 leading-relaxed max-w-3xl"
        >
          Bullying affects everyone — families who feel unheard, students who feel unsafe, and schools trying to do right by their communities. Veric gives everyone a better way forward.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.4, ease: [0.21, 0.47, 0.32, 0.98] }}
          className="mt-10 md:mt-14 flex flex-col sm:flex-row items-center gap-4"
        >
          <button
            onClick={scrollToWaitlist}
            className="w-full sm:w-auto px-10 py-5 bg-navy text-white text-lg font-bold rounded-xl hover:bg-deep-blue transition-all active:scale-[0.98] shadow-xl shadow-navy/10"
          >
            Join the Waitlist
          </button>
          
          <a
            href="https://tally.so/r/QKx7Rl"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full sm:w-auto px-10 py-5 bg-white text-navy border-2 border-navy/10 text-lg font-bold rounded-xl hover:border-navy/20 hover:bg-gray-50 transition-all active:scale-[0.98] text-center"
          >
            Fill out Questionnaire
          </a>
        </motion.div>
      </div>
    </section>
  );
}